export const FhirConstants = {
  EXTENSION_URL: "https://medialhealth.com/FHIR-Extensions",
};
